import React from 'react';
import styled from 'styled-components';

import { CheckIcon } from 'LegacyWeployDesignLanguage/icons';
import Grid from 'LegacyWeployDesignLanguage/Grid';

const Title = styled.h5`
  margin: 0 0 ${props => props.theme.space.quarter} 0;
`;

const TestItem = styled.span`
  margin-left: ${props => props.theme.space.quarter};
  font-size: ${props => props.theme.typography.normal};
`;

const TestItemsContainer = styled.div`
  margin-top: ${props => props.theme.space.half};
`;

const StyledCheckIcon = styled(CheckIcon)`
  &.MuiSvgIcon-root {
    color: ${props => props.theme.colors.brand.primary};
  }
`;

const StyledGrid = styled(Grid)`
  display: flex;
`;

const renderTestItems = items => (
  <TestItemsContainer>
    <Grid container justify="space-between">
      {
        items.map(item => (

          <StyledGrid item xs={6} key={item}>
            <StyledCheckIcon type={CheckIcon.OUTLINED} />
            <TestItem>{item}</TestItem>
          </StyledGrid>
        ))
      }
    </Grid>
  </TestItemsContainer>
);

const VettingProcess = () => (
  <div>
    <Title>Hire quality everytime</Title>
    All Weployees are quality assured by our Internal Talent Assessment Team.
    { renderTestItems([
        'Psychometric test',
        'Skills test',
        'Face to face interview',
        'Police and Work rights',
        'Cognitive and emotional intelligence (EQ)',
      ])
    }
  </div>
);

export default VettingProcess;
